export default (description, title) => {
  return {
    'event': 'view_promotion',
    'funnel_name': 'MYB',
    'sub_funnel_name': 'Credit Card Promotion',
    'items': [{
      'item_id': 'NA',
      'item_name': description,
      'creative_name': title,
      'creative_slot': 'NA',
      'discount': 0,
      'price': 0,
    }],
  };
};
